<div class="main">
  <nz-spin nzTip="Loading..." [nzSpinning]="nzSpinning" nzSize="large">
    <div class='body'>
      <div class="title">
        <h3 [ngStyle]="{ 'margin-bottom.px': 10,'margin-top.px': 10 }">{{title}}</h3>
      </div>
      <!-- 单据版本 -->
      <div class="versionGroup">
        <button nz-button class="button-search" (click)="showModal(item)" *ngFor="let item of versionArr">
          <em nz-icon nzType="read"></em>
          {{ 'Common.VERSION' | translate }}&nbsp;{{ item }}
        </button>
      </div>
      <!-- 基础资料 工程分类 描述与详情 -->
      <div class="base-data" *ngIf="baseDataStatus">
        <app-base-data [isEdit]="isEdit" [step]="step" [DetailData]="DetailData" [electromechanical]="electromechanical"
          [civilEngineering]="civilEngineering" [activeBtn]="activeBtn" (submitDataEvent)="submitDataEvent($event)"
          [isEditImage]="isEditImage" [nzShowButton]="nzShowButton" [nzShowUploadList]="nzShowUploadList">
        </app-base-data>
      </div>
      <!-- 审核结果 -->
      <div class="assign-status" *ngIf="assignStatus">
        <app-assign-status [step]="step" (radioChangEmitter)='radioChangEmitter($event)'></app-assign-status>
      </div>
      <!-- 厂务课级签核:工程分类明细  派单厂务工程师 选择厂商-->
      <div class="task-assign" *ngIf="taskAssignStatus">
        <app-task-assign [taskAssignEdictStatus]="taskAssignEdictStatus" [taskAssignDisabled]="taskAssignDisabled"
          [formid]="formid" [electromechanical]="electromechanical" [civilEngineering]="civilEngineering"
          (submitTaskAssignDataEvent)="submitTaskAssignDataEvent($event)"
          [vendorTaskAssignEdictStatus]="vendorTaskAssignEdictStatus"
          [engineerTaskAssignEdictStatus]="engineerTaskAssignEdictStatus" [appAppointStatus]="appAppointStatus"
          [appointEditStatus]="appointEditStatus" [getAssignPhone]="getAssignPhone">
        </app-task-assign>
      </div>
      <!-- 预约厂商:预约厂商查看现场与标单信息 实际厂商查看现场与标单信息 -->
      <div class="appoint-task" *ngIf="appAppointStatus">
        <app-appoint-task [appAppointStatus]="appAppointStatus" [appointEditStatus]="appointEditStatus"
          [makeBudgetEstimatesStatus]="makeBudgetEstimatesStatus"
          [editBudgetEstimatesStatus]="editBudgetEstimatesStatus" [reviewResultIsReject]="reviewResultIsReject"
          [electromechanical]="electromechanical" [civilEngineering]="civilEngineering" [formid]="formid" [step]="step"
          [activeBtn]="activeBtn" (submitAppointTaskDataEvent)="submitAppointTaskDataEvent($event)"
          (submitActualTaskDataEvent)="submitActualTaskDataEvent($event)">
        </app-appoint-task>
      </div>
      <!-- 厂商标单制定:标单制定 -->
      <div class="make-bid" *ngIf="makeBidStatus">
        <app-make-bid [makeBidEditStatus]="makeBidEditStatus" [formid]="formid" [getAssignPhone]="getAssignPhone"
          (getSubmitBidSaveData)="getSubmitBidSaveData($event)">
        </app-make-bid>
      </div>

      <!-- 厂务概算制定:专案分类 标单详情 -->
      <div class="make-budget-estimates" *ngIf="makeBudgetEstimatesStatus">
        <app-make-budget-estimates [makeBudgetEstimatesStatus]="makeBudgetEstimatesStatus"
          [editBudgetEstimatesStatus]="editBudgetEstimatesStatus" [reviewResultIsReject]="reviewResultIsReject"
          [formid]="formid" [getAssignPhone]="getAssignPhone" [getProjectCategory]="getProjectCategory" [step]="step"
          [isDownLoadBid]="isDownLoadBid" [civilEngineering]="civilEngineering" [electromechanical]="electromechanical"
          [getFormBudgetCharge]="getFormBudgetCharge" (getSubmitBudgetSaveData)="getSubmitBudgetSaveData($event)"
          (sendProjectCategory)="sendProjectCategory($event)"
          (budgetCodeAndCreditDepartment)="budgetCodeAndCreditDepartment($event)">
        </app-make-budget-estimates>
      </div>

      <!-- 报价单上传 -->
      <app-upload-quotation *ngIf="uploadQuotationStatus" [step]="step" [formid]="formid" [activeBtn]="activeBtn"
        [getProjectCategory]="getProjectCategory" [civilEngineering]="civilEngineering"
        [electromechanical]="electromechanical" [uploadQuotationEditStatus]="uploadQuotationEditStatus"
        [nzShowButtonOfUploadQuotation]="nzShowButtonOfUploadQuotation"
        [nzShowUploadListOfUploadQuotation]="nzShowUploadListOfUploadQuotation"
        (quotationAmount)="quotationAmount($event)" (quotationAttach)="quotationAttach($event)">
      </app-upload-quotation>

      <!-- PR/PO信息 -->
      <app-prpo-info *ngIf="PRPOInfoStatus" [formid]="formid" [civilEngineering]="civilEngineering"
        [electromechanical]="electromechanical">
      </app-prpo-info>

      <!-- 审核结果 -->
      <div class="review-result" *ngIf="reviewResultStatus">
        <app-review-result [step]="step" [getProjectCategory]="getProjectCategory"
          [electromechanical]="electromechanical" [civilEngineering]="civilEngineering"
          (reviewResultChangEmitter)="reviewResultChangEmitter($event)"
          (budgetCodeAndCreditDepartment)="budgetCodeAndCreditDepartment($event)">
        </app-review-result>
      </div>

      <!-- 签核记录 -->
      <div class="send-order" *ngIf="sendOrderStatus">
        <app-send-orders [formid]="formid" [electromechanical]="electromechanical"
          [civilEngineering]="civilEngineering">
        </app-send-orders>
      </div>
    </div>
    <!-- 签核按钮:1.提交||变更需求;2.取消;3.返回 -->
    <div class="sign-button">
      <div class="threeBtn" *ngIf="btnStatus['submitCancelReture']">
        <button (click)="editFn()">{{ editBtnName | translate }}</button>
        <button style="background-color: rgb(187, 102, 102)" (click)="cancelOrReturnFn('cancel')">{{ cancelBtnName |
          translate }}</button>
        <button style="background-color: #d1926a" (click)="cancelOrReturnFn('return')">{{ returnBtnName | translate
          }}</button>
      </div>
      <div class="twoBtn" *ngIf="btnStatus['submitReture']">
        <button (click)="editFn()">{{ editBtnName | translate }}</button>
        <button style="background-color:#d1926a" (click)="cancelOrReturnFn('return')">{{ returnBtnName | translate
          }}</button>
      </div>
      <div class="twoBtn" *ngIf="btnStatus['cancelReture']">
        <button style="background-color: rgb(187, 102, 102)" (click)="cancelOrReturnFn('cancel')">{{ cancelBtnName |
          translate }}</button>
        <button style="background-color:#d1926a" (click)="cancelOrReturnFn('return')">{{ returnBtnName | translate
          }}</button>
      </div>
      <div class="oneBtn" *ngIf="btnStatus['reture']">
        <button style="background-color: #d1926a" (click)="cancelOrReturnFn('return')">{{ returnBtnName | translate
          }}</button>
      </div>
    </div>
    <nz-modal class="cancelModal" [(nzVisible)]="isCancel" nzTitle="{{'DetailInfo.cancelDoc' | translate }}"
      (nzOnCancel)="handleCancelCancel()" (nzOnOk)="handleCancelOk()">
      <div *nzModalContent>
        <p style="font-size: 18px; font-weight: bold;">{{ 'CommonMessageTip.cancelDocTip' | translate }}</p>
        <div>
          <p>{{ 'DetailInfo.cancelReason' | translate }}({{'Common.Optional' | translate}}): </p>
          <input nz-input placeholder="{{'DetailInfo.cancelReasonPlaceholder' | translate }}"
            [(ngModel)]="cancelReason" />
        </div>
      </div>
    </nz-modal>
  </nz-spin>
</div>
<!-- 历史版本数据 -->
<nz-modal class="nzModal" [(nzVisible)]="isVisible" nzTitle={{modalTitle}} (nzOnCancel)="handleCancel()"
  [nzFooter]="null" (nzOnOk)="handleOk()" [nzWidth]='900' [nzBodyStyle]="{background: 'rgb(231, 236, 236)'}">
  <ng-container *nzModalContent>
    <app-base-data [DetailData]="historyDetailData" [electromechanical]="historyElectromechanical"
      [civilEngineering]="historyCiviEngineering" [activate]="true" [nzShowUploadList]="nzShowUploadList">
    </app-base-data>
  </ng-container>
</nz-modal>